"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _togaInput = _interopRequireDefault(require("@thinkific/toga-input"));

var _Dropdown = _interopRequireDefault(require("../Dropdown.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var cx = _bind["default"].bind(_Dropdown["default"]);

var Filter = function Filter(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      placeholder = _ref.placeholder;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: cx('dropdown__filter')
  }, /*#__PURE__*/_react["default"].createElement(_togaInput["default"], {
    handleChange: onChange,
    initValue: value,
    placeholder: placeholder,
    hasNoGroup: true
  }));
};

Filter.displayName = 'Filter';
Filter.propTypes = {
  /** Value of the placeholder text */
  placeholder: _propTypes["default"].string,

  /** Value of the filter text */
  value: _propTypes["default"].string,

  /** Handler on change of the filter text */
  onChange: _propTypes["default"].func.isRequired
};
Filter.defaultProps = {
  /** Default value of the filter text */
  value: '',

  /** Default value of the placeholder text */
  placeholder: 'Search'
};
var _default = Filter;
exports["default"] = _default;